import { useSelector } from 'react-redux';
import { CompanyPlanLevel, CompanyPlanStatus } from '../enum/CompanyPlanLevelEnum';
import { useGetStoreById } from './stores/queries';

const useCanUseMercadoPago = (
  storeId: string
): { storeCanUseMP: boolean; companyCanUseMP: boolean } => {
  const { data: store } = useGetStoreById(!!storeId, storeId);
  const { company } = useSelector((state: any) => state.user);
  const isStandardOrPremium = [CompanyPlanLevel.STANDARD, CompanyPlanLevel.PREMIUM].includes(
    company.planLevel
  );
  const isInGraceOrSuspended = [CompanyPlanStatus.GRACE, CompanyPlanStatus.SUSPENDED].includes(
    company.planStatus
  );
  
  return {
    storeCanUseMP: isStandardOrPremium && !!store?.mpSettings?.enabled && !isInGraceOrSuspended,
    companyCanUseMP: isStandardOrPremium && !isInGraceOrSuspended
  };
};

export default useCanUseMercadoPago;
